
import Introjs from "plugins/introjs/index"
import BrowserDetection from "app/detection/browser"
import {Page} from "app/multi_device"
import ActionWithTimeout from "app/action_with_timeout"
import Filter_Manager from "app/search/filter/manager"


import I18n from "plugins/i18n-js"


const COMPLETE_TUTORIAL_OVERLAY_COOKIE_KEY = "window.App.Cells.ListingFilter.TutorialOverlay.Completed"

const INTRO_JS_STEPS = [
  {
    element:  ".btn-save-search-prompt",
    intro:    I18n.t("concepts.listings.searches.saved.button.tutorial"),
    position: "bottom" as "bottom",
  },
]

const show = () => {
  // # This tutorial is only shown when there are enough filter options changed
  // TODO: refactor
  import(
    "concepts/listings/searches/filter_bar/index"
  )
  .then(({Factory: ListingFilter}) => {
    if (ListingFilter.instance().count() < 2) return

    // # Only show at most once per 2 days
    ActionWithTimeout.execute(
      COMPLETE_TUTORIAL_OVERLAY_COOKIE_KEY,
      24 * 3600 * 2,
      () => {
        Introjs.init(INTRO_JS_STEPS)
        .then((intro_js_object) => intro_js_object.start())
      }
    )
  })
}

const onLoad = () => {
  // # The overlay won't work on old browsers
  if (BrowserDetection.isIE8OrLess()) return
  // # This tutorial only works for desktop (for now)
  if (!Page.isForDesktop()) return

  Filter_Manager.on("filter:update:action", () => {
    show()
  })
}

export default {onLoad}
